/* ── CarbonTree speed fix: size taps (22 Sep 2026) ─────────────────────────
   Measured on the live product page (Carbon Heavyweight, Carbon Black): a
   size tap spent ~280ms inside the theme's own code before the screen could
   update, which Shopify's speed report showed as slow taps on phones.
   Two causes, fixed here WITHOUT editing the theme's original files:

   1. The photo gallery copied all 40 slides and re-measured the slider on
      EVERY tap — even though picking a size never changes the photos. It now
      checks first and only rebuilds when the photos really change.
   2. Updating the address bar (?variant=…) woke up every tracker hooked to it
      (7 copies of Google's tag, Clarity, …) inside the tap. The address still
      changes instantly; the trackers hear about it a moment later, right
      after the screen has updated — so analytics behave exactly as before.

   To undo: delete the ct-speed-fixes.js line in layout/theme.liquid. */
(function () {
  if (!window.customElements || window.__ctSpeedFix) return;
  window.__ctSpeedFix = true;

  // 1. gallery: skip the copy-and-rebuild when the photos wouldn't change
  customElements.whenDefined('gallery-section').then(function () {
    var G = customElements.get('gallery-section');
    var original = G && G.prototype.filterSlides;
    if (!original) return;
    G.prototype.filterSlides = function (options, featured_media_id, matchAll, callback) {
      if (matchAll === undefined) matchAll = true;
      if (!this.elements || !this.filterSlidesByOptions || !this.sortSlides) {
        return original.call(this, options, featured_media_id, matchAll, callback);
      }
      var getId = function (el) { return el && el.dataset ? el.dataset.mediaId : undefined; };
      var all = Array.from(this.elements.gallerySlides);
      var preview = this.filterSlidesByOptions(all, options, featured_media_id, matchAll);
      if (preview.length === 0) preview = all.slice();
      if (featured_media_id) preview = this.sortSlides(preview, featured_media_id);
      var unchanged = this.renderedSlides && this.renderedSlides.length &&
        this.renderedSlides.map(getId).toString() === preview.map(getId).toString();
      if (!unchanged) return original.call(this, options, featured_media_id, matchAll, callback);
      var firstImg = preview[0] && preview[0].querySelector('img');
      this.setActiveMedia(featured_media_id || (firstImg && firstImg.getAttribute('data-media-id')), true);
    };
  });

  // 2. address bar: change it now with the browser's own function (the Add to
  //    cart / Buy now logic right after reads it), tell the trackers after paint
  customElements.whenDefined('variant-options').then(function () {
    var V = customElements.get('variant-options');
    var original = V && V.prototype.updateURL;
    var nativeReplace = window.History && History.prototype.replaceState;
    if (!original || !nativeReplace) return;
    V.prototype.updateURL = function () {
      var hooked = window.history.replaceState;
      if (hooked === nativeReplace) return original.apply(this, arguments);
      window.history.replaceState = function (s, t, u) { return nativeReplace.call(window.history, s, t, u); };
      try { original.apply(this, arguments); } finally { window.history.replaceState = hooked; }
      var url = window.location.href, state = window.history.state;
      requestAnimationFrame(function () {
        setTimeout(function () {
          if (window.location.href === url) hooked.call(window.history, state, '', url);
        }, 0);
      });
    };
  });
})();
/* ── END CarbonTree speed fix: size taps ───────────────────────────────────── */

/* ── CarbonTree bundle pages: two phone fixes (22 Sep 2026) ────────────────
   Runs only on pages with the mix-and-match bundle box (e.g. Utility
   Leggings - Pack of 3). Does nothing anywhere else.
   1. The "Utility Leggings 1 / 2 / 3" slot labels were cut off on phones:
      two lines of 15px text in a 33px-tall space. 12px on phones fits.
   2. The bundle app's button said "Add 3 more item(s)" and the app has no
      setting for that wording. It now reads "Add 3 to finish bundle" and
      counts down as items are picked. It watches only the bundle box, never
      the whole page — measured ~0.1ms per update, so taps stay fast.
   To undo: delete everything from this comment to the matching END line. */
(function () {
  var block = document.getElementById('yt-mixnmatch-bundle-block');
  if (!block || window.__ctBundleFix) return;
  window.__ctBundleFix = true;

  var style = document.createElement('style');
  style.textContent = '@media (max-width: 767px) { .yt-mixMatch-select-text-label { font-size: 12px !important; line-height: 1.2 !important; } }';
  document.head.appendChild(style);

  var rename = function () {
    block.querySelectorAll('.yt-mixMatch-add-to-cart-button').forEach(function (button) {
      var walker = document.createTreeWalker(button, NodeFilter.SHOW_TEXT), node;
      while ((node = walker.nextNode())) {
        if (node.nodeValue === ' more item(s)') node.nodeValue = ' to finish bundle';
      }
    });
  };
  new MutationObserver(rename).observe(block, { childList: true, subtree: true, characterData: true });
  rename();
})();
/* ── END CarbonTree bundle pages ───────────────────────────────────────────── */

/* ── CarbonTree speed fix: taps on pages with product cards (15 Oct 2026) ──
   Measured on the live home page: each of the 104 product cards ran its own
   "close the quick-add size picker" check on EVERY tap anywhere on the page,
   and each check searched the whole page. Together: 27-51ms per tap on a
   laptop, several times that on a phone, before the tap itself could act.
   Now the closing runs once per tap, and only when a size picker is open.
   Same behaviour: a tap outside still closes any open picker, and opening
   one card's picker still closes the others.
   To undo: delete everything from this comment to the matching END line. */
(function () {
  if (!window.customElements || window.__ctCardTapFix) return;
  window.__ctCardTapFix = true;

  customElements.whenDefined('color-swatch').then(function () {
    var C = customElements.get('color-swatch');
    var original = C && C.prototype.updateSizeDisplayWhenClickOutside;
    if (!original) return;
    var lastEvent = null;
    // live lists: checking them is ~30x cheaper than searching the page
    var wrappers = document.getElementsByClassName('size-selector-wrapper');
    var quickAdds = document.getElementsByClassName('custom-quick-add');
    var anyOpen = function () {
      var i;
      for (i = 0; i < wrappers.length; i++) if (!wrappers[i].classList.contains('hidden')) return true;
      for (i = 0; i < quickAdds.length; i++) if (quickAdds[i].classList.contains('hidden')) return true;
      return false;
    };
    C.prototype.updateSizeDisplayWhenClickOutside = function () {
      // every card calls this for the same tap; the first call does the work
      var ev = window.event;
      if (ev) {
        if (ev === lastEvent) return;
        lastEvent = ev;
      }
      // nothing open: closing would change nothing
      if (!anyOpen()) return;
      return original.apply(this, arguments);
    };
  });
})();
/* ── END CarbonTree speed fix: product cards ───────────────────────────────── */
